export function generateAlphaNumeric(length) {
  let result = '';
  while (result.length < length) {
    // Math.random().toString(36) → "0.xyz..." where xyz are alphanumeric
    result += Math.random().toString(36).substring(2);
  }
  return result.substring(0, length);
}
